import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteData,
  type DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteError,
  type DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteResponse,
  deletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDelete,
} from '../../generated';

export type DeletePdpImageMutationVariables =
  DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteData['path'];

export type DeletePdpImageMutation = DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteResponse;

export const useDeletePdpImageMutation = <
  TError = DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<DeletePdpImageMutation, TError, DeletePdpImageMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<DeletePdpImageMutation, TError, DeletePdpImageMutationVariables, TContext>({
    mutationKey: ['DeletePdpImage'],
    mutationFn: async ({ portfolio_id, pdp_id, image_id }: DeletePdpImageMutationVariables) => {
      const { data } = await deletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDelete({
        path: { portfolio_id, pdp_id, image_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useDeletePdpImageMutation.fetcher = (
  { portfolio_id, pdp_id, image_id }: DeletePdpImageMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await deletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDelete({
      path: { portfolio_id, pdp_id, image_id },
      throwOnError: true,
    });
    return data;
  };
};
